import ApplicationController from "./application_controller"

export default class extends ApplicationController {
  static values = {
    options: Object
  }

  async connect () {
    super.connect()

    await this.loadLibrary()
    await this.createPlayer()
  }

  async loadLibrary () {
    if (customElements.get('lottie-player')) return

    await import("@lottiefiles/lottie-player")
  }

  async createPlayer () {
    if (this.player) return

    const player = document.createElement('lottie-player')
    Object.assign(player, this.optionsValue)

    this.element.appendChild(player)
  }

  get player () {
    return this.element.querySelector('lottie-player')
  }
}
